import type {CurrentThreadPositioning, ThreadSubjectType} from '../conversation-types'
import type {LineKey} from '../types'

/** Builds a marker key from the end line of a position; file-level positions have no line key. */
export function positioningToLineKey(positioning: CurrentThreadPositioning | undefined): LineKey | undefined {
  if (positioning?.endLine === null || positioning?.endLine === undefined) return undefined
  const side = positioning.endDiffSide === 'RIGHT' ? 'R' : 'L'
  return `${side}${positioning.endLine}`
}

/**
 * Normalizes subject type values from the various thread and comment sources (e.g. `line`, `MULTILINE`, `FILE`).
 * Multiline threads are considered line threads.
 */
export function toThreadSubjectType(subjectType: string | null | undefined): ThreadSubjectType | undefined {
  switch (subjectType?.toUpperCase()) {
    case 'FILE':
      return 'FILE'
    case 'LINE':
    case 'MULTILINE':
      return 'LINE'
    default:
      return undefined
  }
}

export function fileCurrentPositioning(path: string, isOutdated: boolean): CurrentThreadPositioning {
  return {
    path,
    startLine: null,
    startDiffSide: null,
    endLine: null,
    endDiffSide: null,
    isOutdated,
  }
}
